import { render, staticRenderFns } from "./login-incentives.vue?vue&type=template&id=85ccdc8a&scoped=true"
import script from "./login-incentives.vue?vue&type=script&lang=js"
export * from "./login-incentives.vue?vue&type=script&lang=js"
import style0 from "./login-incentives.vue?vue&type=style&index=0&id=85ccdc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ccdc8a",
  null
  
)

export default component.exports